
import { BrowserRouter } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import CartSlidePanel from './components/feature/CartSlidePanel';
import CookieConsent from './components/feature/CookieConsent';
import { setCartOpener } from './hooks/useCart';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Set up global cart opener
  useEffect(() => {
    setCartOpener(() => setIsCartOpen(true));
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <div>
        <AppRoutes />
      </div>
      <CartSlidePanel isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
